var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagicBoxLimitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_radial_4148_97712)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_4148_97712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 51L32 47L50 51L32 56L14 51Z",
    fill: "#1A1B1D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 29.12L14 24V42.24L30 47.36V29.12ZM34 29.12V47.36L50 42.24V24L34 29.12Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21L32 17L50 21L32 26L14 21Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 49.397 49.897 63.5 32.5 63.5C15.103 63.5 1 49.397 1 32C1 14.603 15.103 0.5 32.5 0.5C49.897 0.5 64 14.603 64 32Z",
    stroke: "white",
    strokeOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 5C51.4157 7.56542 53.4346 9.58432 56 10.5C53.4346 11.4157 51.4157 13.4346 50.5 16C49.5843 13.4346 47.5654 11.4157 45 10.5C47.5654 9.58432 49.5843 7.56542 50.5 5Z",
    fill: "#1A1B1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0357 3C58.5411 4.41598 59.6555 5.53031 61.0714 6.03571C59.6555 6.54112 58.5411 7.65545 58.0357 9.07143C57.5303 7.65545 56.416 6.54112 55 6.03571C56.416 5.53031 57.5303 4.41598 58.0357 3Z",
    fill: "#1A1B1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0357 11.5C59.5411 12.916 60.6555 14.0303 62.0714 14.5357C60.6555 15.0411 59.5411 16.1555 59.0357 17.5714C58.5303 16.1555 57.416 15.0411 56 14.5357C57.416 14.0303 58.5303 12.916 59.0357 11.5Z",
    fill: "#1A1B1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4148_97712",
    x: 10,
    y: 43,
    width: 44,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4148_97712"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4148_97712",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5 32) rotate(90) scale(28)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicBoxLimitation);
export default __webpack_public_path__ + "static/media/magic-box-limitation.7915339720d505c77f4c00c5d131059a.svg";
export { ForwardRef as ReactComponent };